import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterStats = ({ totalRoles, filteredRoles, searchTerm }) => {
  if (!searchTerm?.trim() && filteredRoles === totalRoles) {
    return null;
  }

  return (
    <div className="bg-white bg-opacity-5 backdrop-blur-sm border border-white border-opacity-10 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="flex items-center space-x-2 text-blue-200">
            <Icon name="Filter" size={16} />
            <span className="font-caption text-sm">Search Results</span>
          </div>
          
          {searchTerm?.trim() && (
            <div className="flex items-center space-x-2">
              <span className="text-blue-300 font-caption text-sm">for</span>
              <div className="bg-purple-500 bg-opacity-30 px-3 py-1 rounded-full">
                <span className="text-purple-200 font-medium text-sm">"{searchTerm}"</span>
              </div>
            </div>
          )}
        </div>

        <div className="text-right">
          <div className="text-white font-medium">
            {filteredRoles?.toLocaleString()} of {totalRoles?.toLocaleString()}
          </div>
          <div className="text-blue-300 font-caption text-xs">
            character role{filteredRoles !== 1 ? 's' : ''} found
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterStats;